import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { AuthProvider } from './features/auth/AuthContext'
import { CartProvider } from './features/play/CartContext'
import './styles/tokens.css'
import './styles/app.css'

createRoot(document.getElementById('root')!).render(<StrictMode><BrowserRouter><AuthProvider><CartProvider><App/></CartProvider></AuthProvider></BrowserRouter></StrictMode>)
